import { useEffect, useRef, useLayoutEffect } from "react";

export function useCollapsible(isOpen: boolean) {
  const ref = useRef<HTMLDivElement>(null);

  // Инициализация - устанавливаем начальное состояние ДО первого рендера
  useLayoutEffect(() => {
    if (!ref.current) return;
    const element = ref.current;
    
    // При первом рендере устанавливаем начальное состояние без анимации
    element.style.transition = "none";
    element.style.maxHeight = isOpen ? `${element.scrollHeight}px` : "0px";
    element.style.opacity = isOpen ? "1" : "0";
    element.style.pointerEvents = isOpen ? "auto" : "none";
    element.style.overflow = "hidden";
    
    // Восстанавливаем transition после следующего кадра
    requestAnimationFrame(() => {
      if (ref.current) {
        ref.current.style.transition = "";
      }
    });
  }, []); // Только при монтировании

  useEffect(() => {
    if (!ref.current) return;
    const element = ref.current;

    const scrollHeight = element.scrollHeight;
    const maxHeight = isOpen ? `${scrollHeight}px` : "0px";
    
    element.style.maxHeight = maxHeight;
    element.style.opacity = isOpen ? "1" : "0";
    element.style.pointerEvents = isOpen ? "auto" : "none";
    element.style.overflow = "hidden";

    const handleTransitionEnd = () => {
      if (isOpen && ref.current) {
        // При открытии устанавливаем auto чтобы контент мог расширяться
        ref.current.style.maxHeight = "auto";
      }
      element.removeEventListener("transitionend", handleTransitionEnd);
    };

    element.addEventListener("transitionend", handleTransitionEnd);
    
    return () => {
      element.removeEventListener("transitionend", handleTransitionEnd);
    };
  }, [isOpen]);

  useEffect(() => {
    if (!ref.current) return;

    const updateHeight = () => {
      if (!ref.current) return;
      const element = ref.current;
      
      // Только обновляем высоту если открыто (при закрытом maxHeight=0)
      if (isOpen) {
        const scrollHeight = element.scrollHeight;
        element.style.maxHeight = `${scrollHeight}px`;
      }
    };

    const observer = new MutationObserver(() => {
      updateHeight();
    });

    observer.observe(ref.current, {
      childList: true,
      subtree: true,
      characterData: true
    });

    return () => observer.disconnect();
  }, [isOpen]);

  return ref;
}
